// src/components/resources/quizzes/components/QuestionDisplay.tsx

'use client'

import type { QuestionDisplayProps } from '~/components/resources/quizzes/types/quiz-types'

export function QuestionDisplay({ question, questionNumber }: QuestionDisplayProps): JSX.Element {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-xs font-semibold text-indigo-600 dark:bg-indigo-900/50 dark:text-indigo-400">
          Q{questionNumber}
        </span>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          {question.label}
        </h3>
      </div>
    </div>
  )
} 